import React, { useContext, useEffect, useRef } from 'react';
import './NavbarLg.css'
import Image from '../shared/Image';
import logo from './../../public/image/logo192.png'
import Select from 'react-select';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import MainContext from '../../context/mainContext';
import Login from './Login/Login';
import { Dropdown } from 'react-bootstrap';
import { userLogout } from '../../service/userService';
import SearchContext from '../../context/searchContext';
import { usePWAInstall } from 'react-use-pwa-install';

const NavbarLg = () => {

    const { pathname } = useLocation();
    const context = useContext(MainContext)
    const searchContext = useContext(SearchContext)
    const navigate = useNavigate();
    const focusInputRef = useRef(null);
    const ref = useRef(null);
    const install = usePWAInstall()


    useEffect(() => {
        pathname !== '/search' && setTimeout(() => {
            searchContext.onChangeSearch('')
            ref.current && ref.current.blur()
        }, 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname])

    const getShoppingCartCount = () => {
        const { shoppingCart } = context;
        let count = 0;
        try {
            shoppingCart.forEach(item => {
                count += item.count;
            });
        } catch (error) {

        }
        return count;
    }

    return (
        <nav className='navbarLg'>
            <div style={{ marginRight: '10px' }}>
                <Image
                    src={logo}
                    width={65}
                    height={65}
                />
            </div>
            <div className='search-bar'>
                <Select
                    placeholder={
                        <div className='d-flex h-100 w-100 align-items-center'>
                            <div style={{ marginLeft: '7px', display: 'inline-block', fontSize: ".9rem" }}>جستجو در محصولات</div>
                            <b className='text-danger'>البرز مارکت</b>
                            <div className='ms-auto'>
                                <i className='fa fa-search ' style={{ fontSize: '.9rem'}}></i>
                            </div>
                        </div>
                    }
                    onInputChange={(value) => {
                        if (!value && !focusInputRef.current) {
                            return
                        }
                        else {
                            return searchContext.onChangeSearch(value);
                        }
                    }}
                    inputValue={searchContext.searchInput}
                    onFocus={() => (focusInputRef.current = true)}
                    onBlur={() => { (focusInputRef.current = false) }}
                    ref={ref}
                    isClearable={false}
                    isSearchable={true}
                    isMulti={false}
                    hideSelectedOptions={true}

                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            boxShadow: state.isFocused
                                ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                : "none",
                            borderColor: state.isFocused
                                ? "#fff2e6"
                                : "#dee2e6",
                            width: "100%",
                            minHeight: '50px',
                            fontSize: '1rem',
                            borderRadius: '0.375rem'
                        }),
                        menuList: (baseStyles, state) => ({
                            ...baseStyles,
                            maxHeight: "120px",
                            textAlign: "right",
                        }),
                        menu: (baseStyles) => ({
                            ...baseStyles,
                            zIndex: '3',
                            display: 'none'
                        }),

                    }}
                    theme={(theme) => ({
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary25: "#ddd",
                            primary: "#0a58ca",
                        },
                    })}
                    isRtl={true}

                />
            </div>

            {
                !context.loggedIn ?
                    <React.Fragment>
                        <button
                            className='btn btn-outline-secondary  d-flex align-items-center ms-auto'
                            onClick={context.showLogin}
                        >
                            <i className='fa fa-sign-in me-2 fs-5'></i>
                            ورود | ثبت نام
                        </button>
                        {
                            window.innerWidth >= 992 &&
                            <Login
                                show={context.showLoginModal}
                                onCancel={context.hideLogin}
                            />
                        }
                    </React.Fragment>
                    :
                    <span className="nav-dropdown rtl ms-auto">
                        <Dropdown className="d-inline-block  navbar-dropdown">
                            <Dropdown.Toggle variant="" id="dropdown-basic">
                                <span className="online-blinker "></span>
                                <i className="fa fa-user-circle-o userNameIcon"></i>
                                <span className="text-dark userName">
                                    {context.loggedIn && context.loggedIn.name}
                                </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="py-1">
                                {
                                    (context.loggedIn && context.loggedIn.isAdmin) &&
                                    <React.Fragment>
                                        <Dropdown.Item
                                            onClick={() => navigate('/dashboard')}
                                        >
                                            <span><i className="fa fa-sign-in"></i>پنل مدیریت</span>
                                            <span className="badge badge-success badge-pill ml-2">
                                                {
                                                    context.shoppingCart.length
                                                }
                                            </span>
                                        </Dropdown.Item>
                                        <Dropdown.Divider />
                                    </React.Fragment>

                                }
                                <Dropdown.Item
                                    onClick={() => navigate('/userInfo')}
                                >
                                    <span><i className="fa fa-pencil"></i>ویرایش اطلاعات</span>
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item
                                    onClick={() => navigate('/userOrders')}
                                >
                                    <span><i className="fa fa-list"></i>سفارشات</span>
                                </Dropdown.Item>
                                {
                                    install &&
                                    <React.Fragment>
                                        <Dropdown.Divider />
                                        <Dropdown.Item
                                            onClick={install}
                                        >
                                            <span ><i className="fa fa-download"></i> نصب برنامه </span>
                                        </Dropdown.Item>
                                    </React.Fragment>
                                }
                                <Dropdown.Divider />
                                <Dropdown.Item
                                    onClick={() => {
                                        (async () => {
                                            try {
                                                await userLogout();
                                                localStorage.removeItem('token')
                                                context.logout();
                                            } catch (error) { }
                                        })();
                                    }}
                                >
                                    <span ><i className="fa fa-sign-out"></i> خروج از حساب </span>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </span>
            }
            <div className='seperator-nav-item'></div>
            <NavLink
                to='/cart'
                className='me-3'
                style={{ width: '70px' }}
            >
                <span
                    className=' badge text-bg-success'
                    style={{ fontSize: '.8rem', opacity: context.shoppingCart.length ? '1' : '0' }}
                >
                    {getShoppingCartCount()}
                </span>
                <i className='fa fa-shopping-cart fs-3 text-secondary'></i>
            </NavLink>
            <section className='col-12 nav-items-section'>
                <NavLink
                    to='/'
                    className={pathname === '/' ? 'text-dark activeItem' : 'text-secondary'}
                >
                    <i className='fa fa-home fs-5 text-secondary'></i>
                    <span style={{ fontSize: '1rem', marginRight: '5px' }}>صفحه اصلی</span>
                </NavLink>
                <NavLink
                    to='/categories'
                    className={pathname === '/categories' ? 'text-dark activeItem' : 'text-secondary'}
                >
                    <i className='fa fa-th-large fs-6 text-secondary'></i>
                    <span style={{ fontSize: '1rem', marginRight: '5px' }}>دسته بندی</span>
                </NavLink>
                <NavLink
                    to='/contact'
                    className={pathname === '/contact' ? 'text-dark activeItem' : 'text-secondary'}
                >
                    <i className='fa fa-phone fs-6 text-secondary'></i>
                    <span style={{ fontSize: '1rem', marginRight: '5px' }}>تماس با ما</span>
                </NavLink>
            </section>
        </nav>
    );
}

export default NavbarLg;